import { Link } from "react-router-dom";
import type { NewsArticle } from "@/types/content";

export default function NewsCard({ article, compact = false }: { article: NewsArticle; compact?: boolean }) {
  if (compact) {
    return (
      <Link
        to={`/news/detail/${article.id}`}
        className="group flex gap-3 py-3 border-b border-background-200 last:border-b-0 cursor-pointer"
      >
        <span className="w-24 h-16 shrink-0 rounded-md overflow-hidden bg-background-100">
          <img
            src={article.thumbnail}
            alt={article.title}
            title={`${article.title} - 影视资讯`}
            className="w-full h-full object-cover object-top"
          />
        </span>
        <div className="min-w-0 flex-1">
          <h4 className="text-sm font-medium text-foreground-900 line-clamp-2 group-hover:text-primary-600 transition-colors">
            {article.title}
          </h4>
          <p className="mt-1 text-xs text-foreground-500">
            {article.date} · {article.category}
          </p>
        </div>
      </Link>
    );
  }

  return (
    <Link
      to={`/news/detail/${article.id}`}
      className="group flex flex-col sm:flex-row gap-4 p-4 rounded-lg bg-background-50 border border-background-200 hover:border-accent-400 transition-colors cursor-pointer"
    >
      <span className="w-full sm:w-52 h-40 sm:h-32 shrink-0 rounded-md overflow-hidden bg-background-100">
        <img
          src={article.thumbnail}
          alt={article.title}
          title={`${article.title} - 影视资讯`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
      </span>
      <div className="min-w-0 flex-1 flex flex-col">
        <div className="flex items-center gap-2 flex-wrap">
          <span className="px-2 py-0.5 rounded-md bg-secondary-100 text-secondary-900 text-xs">
            {article.category}
          </span>
          <span className="text-xs text-foreground-500">{article.date}</span>
        </div>
        <h3 className="mt-2 text-base font-semibold text-foreground-950 line-clamp-2 group-hover:text-primary-600 transition-colors">
          {article.title}
        </h3>
        <p className="mt-1.5 text-sm text-foreground-500 line-clamp-2">{article.summary}</p>
        <span className="mt-auto pt-2 text-xs text-foreground-400">
          来源：{article.source} · {article.author}
        </span>
      </div>
    </Link>
  );
}